import {httpFetch, handleError} from "../Utils/httpUtils";
import {settingsActionTypes as actionTypes} from "../ActionTypes/settingsActionTypes";
import formActions from "./formActions";
import commonActions from "./commonActions";

const appConfigActions = {
    getConfigurations() {
        return dispatch =>
            httpFetch("/api/AppConfig/", dispatch)
                .then(json =>
                    dispatch({type: actionTypes.STORE_APP_CONFIGS, data: json})
                )
    },
    getEditModel(config, callback) {
        return dispatch =>
            httpFetch(`/api/AppConfig/${config.name}/edit`, dispatch)
                .then(json => {
                        dispatch(formActions.startFormEditing(
                            config.name,
                            {value: json.value, schema: json.schema},
                            null,
                            null
                        ));
                        callback();
                    }
                )
    },
    saveConfiguration(form, callback) {
        return dispatch => {
            dispatch(commonActions.hideAlert());

            const httpRequest = {
                method: 'PUT',
                body: JSON.stringify(form.data.value)
            }

            return fetch(`/api/AppConfig/${encodeURIComponent(form.id)}/edit`, {
                ...httpRequest,
                credentials: 'include',
                headers: {'Content-Type': 'application/json'}
            })
                .then(async (response) => {
                    if (response.status === 400) {
                        const payload = await response.json().catch(() => null);
                        const errors = payload?.errors ?? [];
                        const errorMap = {};
                        for (const e of errors) {
                            if (e.path) errorMap[e.path] = e.message;
                        }
                        dispatch(formActions.setFormValidity(form.id, errorMap));
                        dispatch(commonActions.showError(
                            errors.map(e => e.path ? `${e.path}: ${e.message}` : e.message).join('\n') || 'Validation failed',
                            'Validation failed'
                        ));
                        return;
                    }
                    if (!response.ok) throw {response};

                    dispatch(formActions.cancelFormEditing(form.id));
                    dispatch(appConfigActions.getConfigurations());

                    if (callback) callback();

                    dispatch(commonActions.showSuccess('Configuration saved successfully'));
                })
                .catch(error => handleError(dispatch, error))
        }
    },
}

export default appConfigActions;
